<template>
  <v-content>
    <Email />

    <v-overlay :value="overlay" opacity="0.95" z-index="9">
      <v-card
        v-scroll.self="onScroll"
        class="overflow-y-auto"
        max-height="750"
        style="width: 1200px; background: rgba(48, 64, 87, 0.6); padding: 30px; position: relative; top: -40px; bottom: -40px"
      >
        <v-layout row wrap fluid>
          <v-flex xs12 sm12 md12>
            <v-list-item class="mb-margin">
              <v-list-item-content>
                <v-form ref="taskform" lazy-validation aria-autocomplete="off">
                  <br />
                  <v-row>
                    <v-text-field
                      v-model="formFields.contactOwner"
                      class="mg-lr14"
                      label="Representative"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      v-model="formFields.firstName"
                      class="mg-lr14"
                      label="First Name"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.lastName"
                      class="mg-lr14"
                      label="Last Name"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.phone"
                      label="Phone"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.email"
                      label="Email"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.street"
                      label="Street"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-row>
                    <v-text-field
                      v-model="formFields.city"
                      class="mg-lr14"
                      label="City"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      class="mg-lr14"
                      v-model="formFields.state"
                      label="State"
                      outlined
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="formFields.zipcode"
                      class="mg-lr14"
                      label="Zipcode"
                      outlined
                      required
                    ></v-text-field>
                  </v-row>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" text @click="overlay = false"
                      >Close</v-btn
                    >
                    <v-btn
                      class="mx-2"
                      color="green"
                      text
                      outlined
                      @click="submitForm"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>

        <br />
        <br />
      </v-card>

      <br />
      <br />
    </v-overlay>
  </v-content>

  <!-- overlay-->
</template>

<script>
import Email from '@/views/apps/email/Email.vue';

export default {
  name: 'Contacts',
  components: {
    Email,
  },
  data() {
    return {
      scrollInvoked: 0,
      search: '',
      overlay: false,
      itemsPerPage: 10,
      currentField: 0,
      tabs: null,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      formFields: {
        contactOwner: '',
        firstName: '',
        lastName: '',
        contactName: '',
        phone: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
      },
      modal_date_picker: false,
      form_valid: true,

      headers: [
        {
          text: 'Representative',
          value: 'contactOwner',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'First Name',
          value: 'firstName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Last Name',
          value: 'lastName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Phone',
          value: 'phone',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Email',
          value: 'email',
          align: 'center',
          sortable: false,
          divider: true,
        },
      ],
      contactsList: [],
    };
  },

  mounted() {
    this.getContactsList();
    Event.$on('openForm', () => {
      // Event.$off();
      if (this.$route.path !== '/contacts') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('Brand Name');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },

  methods: {
    initialize() {
      this.contactsList = [];
    },

    viewItem(item) {
      this.editedIndex = 0;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.tasks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.tasks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.tasks.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    onScroll() {
      this.scrollInvoked++;
    },
    getContactsList: async function() {
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.contactsList = json.form;
    },

    submitForm: async function() {
      console.log(this.formFields);
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}contact-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('Contact Created');
        this.getContactsList();
      }, 800);
    },
    openForm: function() {
      this.overlay = true;
    },
    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1000);
    },
    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },

    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          this.formFields.contactOwner = msg;
          break;
        case 1:
          this.formFields.firstName = msg;
          break;
        case 2:
          this.formFields.lastName = msg;
          break;
        case 3:
          this.formFields.phone = msg;
          break;
        case 4:
          this.formFields.email = msg;
          break;
        case 5:
          this.formFields.street = msg;
          break;
        case 6:
          this.formFields.city = msg;
          break;
        case 7:
          this.formFields.state = msg;
          break;
        case 8:
          this.formFields.zipcode = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },
    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Representative?');
          break;
        case 1:
          this.readOutLoud('First name?');
          break;
        case 2:
          this.readOutLoud('Last name?');
          break;
        case 3:
          this.readOutLoud('Phone?');
          break;
        case 4:
          this.readOutLoud('Email?');
          break;
        case 5:
          this.readOutLoud('Street ?');
          break;
        case 6:
          this.readOutLoud('City ?');
          break;
        case 7:
          this.readOutLoud('State ?');
          break;
        case 8:
          this.readOutLoud('Zip code ?');
          break;
      }

      this.startListining();
    },
  },
};
</script>

<style scoped>
.db-content {
  background: #304057;
  background-size: 400% 400%;
  padding: 40px;
  min-height: 100vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

.btn-right {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
.mg-lr14 {
  margin: 0px 14px;
}

.scroll {
  overflow-y: scroll;
  height: 100%;
}

.theme-bg-card {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 400px;
}

.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

.theme-bg-card-2 {
  background: rgba(48, 64, 87, 0.6);
  outline-color: #5a80bf;
  color: #fff;
}
</style>
